import { AnalyticsEvents, trackEvent } from "@axqora/analytics";
import type { LandingContent, Locale } from "../content/types";
import { routePath } from "../assets/routes";
import { localizedPaths } from "../i18n/routes";

type FooterProps = {
  content: LandingContent["footer"];
  locale: Locale;
  page?: "home" | "privacy" | "support" | "terms";
};

export function Footer({ content, locale, page = "home" }: FooterProps) {
  const privacyHref = routePath(localizedPaths.privacy[locale]);
  const termsHref = routePath(localizedPaths.terms[locale]);
  const supportHref = routePath(localizedPaths.support[locale]);

  return (
    <footer className="site-footer">
      <div className="site-container footer-layout">
        <div>
          <h2>Prismark</h2>
          <p>{content.tagline}</p>
        </div>
        <nav aria-label="Footer navigation">
          <a
            href={privacyHref}
            onClick={() =>
              trackEvent(AnalyticsEvents.PrivacyClick, {
                product: "prismark",
                page,
                locale,
                target: "footer_privacy"
              })
            }
          >
            {content.privacy}
          </a>
          <a
            href={termsHref}
            onClick={() =>
              trackEvent(AnalyticsEvents.ClickNav, {
                product: "prismark",
                page,
                locale,
                target: "footer_terms"
              })
            }
          >
            {content.terms}
          </a>
          <a
            href={supportHref}
            onClick={() =>
              trackEvent(AnalyticsEvents.SupportClick, {
                product: "prismark",
                page,
                locale,
                target: "footer_support"
              })
            }
          >
            {content.support}
          </a>
          <a
            href="mailto:axqora@gmail.com"
            onClick={() =>
              trackEvent(AnalyticsEvents.ContactClick, {
                product: "prismark",
                page,
                locale,
                target: "footer_mail"
              })
            }
          >
            {content.contact}
          </a>
        </nav>
      </div>
      <div className="site-container footer-bottom">
        <p>
          ©{" "}
          <a
            href="https://axqora.com"
            onClick={() =>
              trackEvent(AnalyticsEvents.ExternalLinkClick, {
                product: "prismark",
                page,
                locale,
                target: "axqora"
              })
            }
          >
            2026 Axqora
          </a>{" "}
          ·{" "}
          <a href={content.icpHref} rel="noopener noreferrer" target="_blank">
            {content.icp}
          </a>
        </p>
      </div>
    </footer>
  );
}
